import { DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  Input,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import { EventParticipant } from '@fantaz/shared/data-access/models';

@Component({
  selector: 'fz-leaderboard',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './leaderboard.component.html',
  styleUrls: ['./leaderboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class LeaderboardComponent {
  @Input({ required: true }) set seats(seats: number) {
    this._seats.set(seats);
  }

  @Input() set participants(participants: EventParticipant[]) {
    this._participants.set(participants);
  }

  _seats = signal<number>(0);
  _participants = signal<any[]>([]);

  leaderboard = computed(() => {
    let el = <any>[];
    let s = this._seats();
    let p = this._participants();

    // add ranks
    p?.forEach((participant, index) => {
      el.push({
        rank: getOrdinal(index + 1),
        name: participant.player,
        date: participant.lastPlayedAt,
      });
    });

    // refill empty ranks

    for (let i = p.length || 0; i < s; i++) {
      el.push({
        rank: getOrdinal(i + 1),
        name: 'Empty',
        date: '',
      });
    }

    return el;
  });
}

function getOrdinal(n: number) {
  const suffixes = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return n + (suffixes[(v - 20) % 10] || suffixes[v] || suffixes[0]);
}
